
const newModel = () => {
    return {
        suachuaDenChieusangId: null,
        trudenChieusangId: null,
        soTrudenChieusang: null,
        soLuong: null,
        ngayBaoHong: null,
        nguoiBaoHong: null,
        tenNguoiBaoHong: null,
        ngayTiepNhan: null,
        nguoiTiepNhan: null,
        tenNguoiTiepNhan: null,
        ngayKhacPhuc: null,
        moTa: null,
        ghiChu: null,
        // enabled: null,
        // enabledDisplay: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        suachuaDenChieusangId: null,
        trudenChieusangId: null,
        soTrudenChieusang: null,
        soLuong: null,
        ngayBaoHong: null,
        tenNguoiBaoHong: null,
        ngayTiepNhan: null,
        tenNguoiTiepNhan: null,
        ngayKhacPhuc: null,
        moTa: null,
        ghiChu: null,
        // enabled: null,
        // enabledDisplay: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null
    }
}

const fromJson = (item) => {
    return {
        suachuaDenChieusangId: item.suachuaDenChieusangId,
        trudenChieusangId: item.trudenChieusangId,
        soTrudenChieusang: item.soTrudenChieusang,
        soLuong: item.soLuong,
        ngayBaoHong: item.ngayBaoHong,
        nguoiBaoHong: item.nguoiBaoHong,
        tenNguoiBaoHong: item.tenNguoiBaoHong,
        ngayTiepNhan: item.ngayTiepNhan,
        nguoiTiepNhan: item.nguoiTiepNhan,
        tenNguoiTiepNhan: item.tenNguoiTiepNhan,
        ngayKhacPhuc: item.ngayKhacPhuc,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        // enabled: item.enabled,
        // enabledDisplay: item.enabled == 1 ? true : false,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        suachuaDenChieusangId: item.suachuaDenChieusangId,
        trudenChieusangId: item.trudenChieusangId,
        soTrudenChieusang: item.soTrudenChieusang,
        soLuong: item.soLuong,
        ngayBaoHong: item.ngayBaoHong,
        nguoiBaoHong: item.nguoiBaoHong,
        tenNguoiBaoHong: item.tenNguoiBaoHong,
        ngayTiepNhan: item.ngayTiepNhan,
        nguoiTiepNhan: item.nguoiTiepNhan,
        tenNguoiTiepNhan: item.tenNguoiTiepNhan,
        ngayKhacPhuc: item.ngayKhacPhuc,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        // enabled: item.enabled,
        // enabledDisplay: item.enabled == 1 ? true : false,

    }
}

const newPagingSearchModel = () => {
    return {
        suachuaDenChieusangId: null,
        trudenChieusangId: null,
        soTrudenChieusang: null,
        soLuong: null,

        nguoiBaoHong: null,
        tenNguoiBaoHong: null,

        nguoiTiepNhan: null,
        tenNguoiTiepNhan: null,


        ngayBaoHongTungay: null,
        ngayBaoHongDenngay: null,
        ngayTiepNhanTungay: null,
        ngayTiepNhanDenngay: null,
        ngayKhacPhucTungay: null,
        ngayKhacPhucDenngay: null,
        moTa: null,
        ghiChu: null,
        // enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        suachuaDenChieusangId: item.suachuaDenChieusangId,
        trudenChieusangId: item.trudenChieusangId,
        soTrudenChieusang: item.soTrudenChieusang,
        soLuong: item.soLuong,
        nguoiBaoHong: item.nguoiBaoHong,
        tenNguoiBaoHong: item.tenNguoiBaoHong,
        nguoiTiepNhan: item.nguoiTiepNhan,
        tenNguoiTiepNhan: item.tenNguoiTiepNhan,
        ngayBaoHongTungay: item.ngayBaoHongTungay,
        ngayBaoHongDenngay: item.ngayBaoHongDenngay,
        ngayTiepNhanTungay: item.ngayTiepNhanTungay,
        ngayTiepNhanDenngay: item.ngayTiepNhanDenngay,
        ngayKhacPhucTungay: item.ngayKhacPhucTungay,
        ngayKhacPhucDenngay: item.ngayKhacPhucDenngay,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        // enabled: item.enabled,
    }
}

const errors = () => {
    return {
        suachuaDenChieusangId: null,
        trudenChieusangId: null,
        soLuong: null,
        ngayBaoHong: null,
        ngayTiepNhan: null,
        ngayKhacPhuc: null,
        moTa: null,
        ghiChu: null,
        // enabled: null,
        // enabledDisplay: null,
        dateCreated: null,
        dateModified: null,
        isDeleted: null,
        dateDeleted: null,
        userCreated: null,
        userModified: null,
        userDeleted: null
    }
}

export const suachuaDenChieusangModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


